import { useEffect } from 'react';
import clsx from 'clsx';

import { IoMdCheckmark, IoMdClose } from 'react-icons/io';
import { usePasswordValidation } from 'views/Auth/hooks';

type PasswordRequirementsProps = {
    password: string;
    confirmPassword: string;
    setIsPasswordValid: (isPasswordValid: boolean) => void;
    isFormTouched: boolean;
};

export default function PasswordValidation({
    password,
    confirmPassword,
    setIsPasswordValid,
    isFormTouched,
}: PasswordRequirementsProps) {
    const passwordValidation = usePasswordValidation(password, confirmPassword);

    useEffect(() => {
        setIsPasswordValid(
            passwordValidation.every(({ condition }) => condition),
        );
    }, [passwordValidation]);

    return (
        <div>
            {isFormTouched &&
                passwordValidation.map(({ text, condition }) => (
                    <div className="flex gap-2">
                        {condition ? (
                            <IoMdCheckmark
                                size={12}
                                className="text-forest-green min-w-12 mt-2"
                            />
                        ) : (
                            <IoMdClose
                                size={12}
                                className="text-lava-red-600 min-w-12 mt-2"
                            />
                        )}
                        <span
                            className={clsx(
                                'text-left text-xs',
                                condition
                                    ? 'text-forest-green'
                                    : 'text-lava-red-600',
                            )}
                        >
                            {text}
                        </span>
                    </div>
                ))}
        </div>
    );
}
